import { bootstrapApplication } from '@angular/platform-browser';
import { App } from '@taxora-accountant-shell/app';
import { appConfig } from '@taxora-accountant-shell/app.config';

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
